define([
	"dojo/_base/declare",
	"csi/utility/stringUtility",
	"Apparel/StructureItemMixin"
], function(declare, {stringSubstitute}, StructureItemMixin) {

	return declare(StructureItemMixin, {
		_resolveViewPath: function(/*csi.view.Widget*/view, /*Relationship?*/r) {
			// summary: substitute correct relationship in path to access StructureItem
			r = r || view.relRoot;

			var apaths = r ? r.m_addPaths : null;

			if (apaths && apaths.length == 2) {
				apaths[0].m_path = stringSubstitute(apaths[0].m_path, [this._resolveViewRelation(view)]);
				apaths[1].m_path = stringSubstitute(apaths[1].m_path, [this._resolveShapeRelation(view)]);
			}
		}

	});
});